module.exports = __webpack_public_path__ + "img/square_rotation_bf.ae723fcc.svg";